import { ModelBase } from 'store/model-base';
import { Manufacturer } from 'core/constants';
import { FindMyDeviceStatusResult } from 'my-account/constants';

export class FindMyDeviceStatus extends ModelBase {
    public static storeName: string = 'findMyDeviceStatus';
    public static idAttribute: string = 'imei';

    public imei: string;
    public manufacturer: Manufacturer;
    public findMyDeviceStatus: FindMyDeviceStatusResult;

    public isOn: boolean;

    public static create<T extends ModelBase>(data: ApiResponse): T {
        data.isOn = data.findMyDeviceStatus === FindMyDeviceStatusResult.ENABLED || data.findMyDeviceStatus === FindMyDeviceStatusResult.UNKNOWN;

        return super.create<T>(data);
    }
}
